import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ALL_PAGES = [
  { path: "/best-real-estate-investment-deals", label: "Best Investment Deals", desc: "Top-scored rental properties nationwide" },
  { path: "/top-deals", label: "Top Deals Today", desc: "Highest cash flow deals updated daily" },
  { path: "/pricing", label: "Pricing Plans", desc: "Free and Pro plan comparison" },
  { path: "/how-scoring-works", label: "How Scoring Works", desc: "Our transparent deal scoring methodology" },
  { path: "/how-to-analyze-rental-properties", label: "How to Analyze Rentals", desc: "Step-by-step investment analysis guide" },
  { path: "/1-percent-rule-real-estate", label: "The 1% Rule", desc: "Quick screening tool for cash flow properties" },
  { path: "/cash-flow-real-estate-explained", label: "Cash Flow Explained", desc: "The 7 expense categories that matter" },
  { path: "/deals/tampa-fl", label: "Tampa, FL Deals", desc: "Investment properties in Tampa" },
  { path: "/deals/jacksonville-fl", label: "Jacksonville, FL Deals", desc: "Investment properties in Jacksonville" },
  { path: "/deals/atlanta-ga", label: "Atlanta, GA Deals", desc: "Investment properties in Atlanta" },
  { path: "/faq", label: "FAQ & Guides", desc: "Common questions and investing guides" },
  { path: "/about", label: "About RealixData", desc: "Our mission and how we help investors" },
  { path: "/contact", label: "Contact Us", desc: "Get in touch with our team" },
];

export default function RelatedPages({ currentPath, maxLinks = 4 }) {
  const links = ALL_PAGES.filter((p) => p.path !== currentPath).slice(0, maxLinks);

  return (
    <section className="py-10 px-4 sm:px-6 border-t border-border" data-testid="related-pages">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-base font-bold mb-4 text-foreground">Explore RealixData</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="group flex items-start gap-3 p-3 rounded-lg border border-border bg-card hover:border-emerald-500/40 transition-colors"
              data-testid={`related-link-${link.path.replace(/\//g, "-").slice(1)}`}
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground group-hover:text-emerald-500 transition-colors">
                  {link.label}
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">{link.desc}</p>
              </div>
              <ArrowRight className="w-3.5 h-3.5 text-muted-foreground group-hover:text-emerald-500 mt-1 flex-shrink-0 transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
